import plural from 'helpers/plural';

angular.module('gym.contacts').controller('AddMembershipCtrl', ["$scope", "$stateParams", "$state", "$document", "$q", "loadingAnimation", "flash", "isInteger", "NewContactService", "MembershipPlanService", "MembershipService", "EmploymentService", "MessageService", "gym", "contact", "newMembershipPlan", "membershipPlans", "membershipPlanCategories", "eventTypes", "gradingStyles", function($scope, $stateParams, $state, $document, $q, loadingAnimation, flash, isInteger, NewContactService, MembershipPlanService, MembershipService, EmploymentService, MessageService, gym, contact, newMembershipPlan, membershipPlans, membershipPlanCategories, eventTypes, gradingStyles) {
  var prefillAllowRecurringBookings, proceedWithSave, save;
  $scope.contact = contact.plain();
  $scope.membershipLimitReachCheck = false;
  $scope.membershipReplacementId = $stateParams.membershipReplacementId ? +$stateParams.membershipReplacementId : void 0;
  $scope.targetMembershipId = $stateParams.targetMembershipId ? +$stateParams.targetMembershipId : void 0;
  $scope.newMembershipPlan = (typeof newMembershipPlan.plain === "function" ? newMembershipPlan.plain() : void 0) || newMembershipPlan;
  $scope.gym = gym;
  $scope.membershipPlans = membershipPlans;
  $scope.membershipPlanCategories = membershipPlanCategories;
  $scope.currentStep = 1;
  $scope.eventTypes = eventTypes;
  $scope.gradingStyles = gradingStyles;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.membership = angular.extend(MembershipPlanService.build(newMembershipPlan), {
    start_date: gym.attributes.today
  });
  $scope.setStep = function(step) {
    return $scope.currentStep = step;
  };
  $scope.validate = function(step) {
    if (contact.id) {
      $scope.membership.contact_id = contact.id;
    }
    return MembershipService.validate($scope.membership, step);
  };
  prefillAllowRecurringBookings = function() {
    var membership;
    membership = $scope.membership;
    if (!gym.attributes.gym_config.recurring_bookings_feature_enabled && (membership.classes_unlimited || (membership.classes_limit > 0 && membership.classes_interval_number > 0))) {
      return $scope.membership.allow_recurring_bookings = true;
    }
  };
  $scope.membershipLimitReached = function() {
    var messageParams;
    messageParams = {
      title: 'Membership purchase limit exceeded',
      message: [`The selected membership plan, <strong>${$scope.membership.label}</strong> allows up to ${plural('purchase', $scope.membership.purchase_limit, true)}.`, 'This limit has been reached, and the plan has now sold out.', "To ignore the limit and add the membership anyway, click 'Override limit' below."],
      confirmButtonText: 'Override limit',
      cancelButtonText: 'Cancel',
      bindHtml: true
    };
    return MessageService.message(messageParams).then(function(res) {
      $scope.membershipLimitReachCheck = true;
      return $scope.membership.skip_purchase_limit_validation = true;
    });
  };
  $scope.submitFirstStep = function() {
    prefillAllowRecurringBookings();
    return $scope.validate(1).then(function() {
      $scope.setStep(2);
      return $document.scrollTop(0);
    }, function(errors) {
      $document.scrollTop(0);
      $scope.membership.errors = errors;
      return flash.error = "Please fix the errors below";
    });
  };
  $scope.submitSecondStep = function() {
    var deferred, ref;
    deferred = $q.defer();
    if (!((ref = $scope.membership.membership_plan) != null ? ref.id : void 0)) {
      $scope.membership.membership_plan = void 0;
    }
    $scope.validate().then(function() {
      return save().then(function() {
        return deferred.resolve();
      }, function() {
        return deferred.reject();
      });
    }, function(errors) {
      $document.scrollTop(0);
      $scope.membership.errors = errors;
      flash.error = "Please fix the errors below";
      return deferred.reject();
    });
    return deferred.promise;
  };
  save = function() {
    var deferred, membershipPlan;
    deferred = $q.defer();
    if (contact.id) {
      membershipPlan = $scope.membership.membership_plan;
      if (membershipPlan != null ? membershipPlan.id : void 0) {
        $scope.membership.membership_plan_id = membershipPlan.id;
        $scope.membership.membership_plan = void 0;
      }
      if ($scope.membership.purchases_remaining === 0 && $scope.membership.purchase_limit && !$scope.membershipLimitReachCheck) {
        $scope.membershipLimitReached().then(function() {
          return proceedWithSave(deferred);
        }, function() {
          return deferred.reject();
        });
      } else {
        proceedWithSave(deferred);
      }
    } else {
      NewContactService.addFormInstance('memberships', $scope.membership);
      deferred.resolve();
      $state.go('gym.contacts.new', {
        section: 'memberships'
      });
    }
    return deferred.promise;
  };
  proceedWithSave = function(deferred) {
    $scope.membership.pending_membership_replacement_id = $scope.membershipReplacementId;
    return contact.doPOST($scope.membership, 'memberships').then(function() {
      flash.success = "Membership added successfully";
      deferred.resolve();
      return $state.go('gym.contacts.edit', {
        contactId: contact.id
      });
    }, function(response) {
      if (response.data.errors.purchase_limit) {
        flash.error = "This membership has sold out. To override the purchase limit, please try again.";
        deferred.resolve();
        $state.go('gym.contacts.edit', {
          contactId: contact.id
        });
      } else {
        $scope.membership.errors = response.data.errors;
        flash.error = "Unable to save membership";
      }
      return deferred.reject();
    });
  };
  $scope.cancel = function() {
    if (contact.id) {
      return $state.go('gym.contacts.edit', {
        contactId: contact.id
      });
    } else {
      return $state.go('gym.contacts.new', {
        section: 'memberships'
      });
    }
  };
  $scope.isFirstStepValid = function() {
    return $scope.membership.label && $scope.membership.membership_plan && moment($scope.membership.start_date, 'YYYY-MM-DD', true).isValid() && $scope.isClassesLimitValid() && $scope.isClassesIntervalValid();
  };
  $scope.isClassesLimitValid = function() {
    var limit;
    limit = $scope.membership.classes_limit;
    return (parseInt(limit, 10) >= 0 && isInteger(limit)) || $scope.membership.classes_unlimited;
  };
  return $scope.isClassesIntervalValid = function() {
    var interval;
    interval = $scope.membership.classes_interval_number;
    return (parseInt(interval, 10) >= 0 && isInteger(interval)) || $scope.membership.not_classes_interval;
  };
}]);
